import { render, staticRenderFns } from "./MessageHints.vue?vue&type=template&id=5b94bcec&scoped=true&"
import script from "./MessageHints.vue?vue&type=script&lang=js&"
export * from "./MessageHints.vue?vue&type=script&lang=js&"
import style0 from "./MessageHints.vue?vue&type=style&index=0&id=5b94bcec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b94bcec",
  null
  
)

export default component.exports